import { AlertCircle, ArrowUpRight, Loader2 } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { useLang } from "@/i18n";

const Thumb = ({ item, tool }) => {
  if (item.status === "done") {
    const src = tool.key === "pdf" ? fileUrl(item.job_id, "original", { page: 0, v: item.unlocked ? 1 : 0 }) : fileUrl(item.job_id, "preview", { v: item.unlocked ? 1 : 0 });
    return <img src={src} alt={item.input_name} loading="lazy" className="max-h-full max-w-full object-contain" />;
  }
  if (item.status === "failed") return <AlertCircle className="h-6 w-6 text-red-500" />;
  return <Loader2 className="h-6 w-6 animate-spin text-slate-400" />;
};

export const BatchList = ({ items, tool, onOpen }) => {
  const { t, tErr } = useLang();
  const done = items.filter((i) => i.status === "done").length;
  return (
    <div data-testid="batch-list" className="rounded-2xl border border-slate-200 bg-white p-6">
      <div className="flex items-baseline justify-between">
        <p className="font-display text-xl font-semibold text-slate-900">{t("batch.title")}</p>
        <p className="font-mono text-xs text-slate-500" data-testid="batch-progress">{t("batch.progress", { d: done, n: items.length })}</p>
      </div>
      <div className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-3">
        {items.map((item, i) => (
          <button key={item.key} data-testid={`batch-item-${i}`} disabled={item.status !== "done"} onClick={() => onOpen(item.job_id)}
            className="group rounded-xl border border-slate-200 p-3 text-left transition-colors hover:border-slate-900 disabled:cursor-default disabled:hover:border-slate-200">
            <div className={`${tool.key === "pdf" ? "bg-slate-100" : "checkerboard"} flex h-32 items-center justify-center overflow-hidden rounded-lg`}><Thumb item={item} tool={tool} /></div>
            <p className="mt-2 truncate text-xs font-medium text-slate-800">{item.input_name}</p>
            <p className="mt-0.5 flex items-center justify-between font-mono text-[10px] uppercase tracking-wider text-slate-400">
              {item.status === "failed" ? <span className="truncate normal-case text-red-600">{tErr(item.error)}</span>
                : item.status === "done" ? <span className="flex items-center gap-1 text-slate-900">{t("batch.open")}<ArrowUpRight className="h-3 w-3" /></span>
                : <span>{item.status === "queued" ? t("batch.queued") : t("history.processing")}</span>}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
};
